import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class LeaseAgreementInformationRow extends ModelBase {
  constructor(source?: Partial<LeaseAgreementInformationRow>) {
    super();
    Object.defineProperties(this, {
      _text: { writable: true, enumerable: false },
      _fromDate: { writable: true, enumerable: false },
      _toDate: { writable: true, enumerable: false },
    });

    if (source) {
      this.id = source.id;
      this.text = source.text;
      this.fromDate = source.fromDate;
      this.toDate = source.toDate;
      this.sortOrder = source.sortOrder;
    }
  }

  sortOrder = 0;
  private _text = '';
  private _fromDate: LocalDate;
  private _toDate: LocalDate;

  get text(): string {
    return this._text;
  }
  set text(value: string) {
    this._text = (value ?? '').replace(/\r\n?/g, '\n');
  }

  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }

  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = value == null ? null : LocalDate.fromDate(value);
  }

  toJSON() {
    return {
      id: this.id,
      text: this.text,
      fromDate: this.fromDate,
      toDate: this.toDate,
      sortOrder: this.sortOrder,
    };
  }
}
